import { Component, Renderer2, OnInit } from '@angular/core';
import { MenuService } from './app.menu.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { SettingsService } from '../services/settings.service';

@Component({
  selector: 'app-main',
  templateUrl: './app.main.component.html',
  animations: [
    trigger('mask-anim', [
      state(
        'void',
        style({
          opacity: 0,
        }),
      ),
      state(
        'visible',
        style({
          opacity: 0.8,
        }),
      ),
      transition('* => *', animate('250ms cubic-bezier(0, 0, 0.2, 1)')),
    ]),
  ],
})
export class AppMainComponent implements OnInit {
  horizontalMenu: boolean;

  darkMode = false;

  menuColorMode = 'light';

  menuColor = 'layout-menu-light';

  themeColor = 'blue';

  layoutColor = 'blue';

  rightPanelClick: boolean;

  rightPanelActive: boolean;

  menuClick: boolean;

  staticMenuActive: boolean; // = true

  menuMobileActive: boolean;

  megaMenuClick: boolean;

  megaMenuActive: boolean;

  megaMenuMobileClick: boolean;

  megaMenuMobileActive: boolean;

  topbarItemClick: boolean;

  topbarMobileMenuClick: boolean;

  topbarMobileMenuActive: boolean;

  configDialogActive: boolean;

  sidebarActive: boolean;

  activeTopbarItem: any;

  topbarMenuActive: boolean;

  menuHoverActive: boolean;

  selectedColorOptions: any;
  darkColors: any;
  lightColors: any;

  constructor(
    public renderer: Renderer2,
    private menuService: MenuService,
    private settingsService: SettingsService,
  ) {
    this.lightColors = [
      { name: 'Blue', file: 'blue', image: 'blue.svg' },
      { name: 'Green', file: 'green', image: 'green.svg' },
      { name: 'Yellow', file: 'yellow', image: 'yellow.svg' },
      { name: 'Cyan', file: 'cyan', image: 'cyan.svg' },
      { name: 'Purple', file: 'purple', image: 'purple.svg' },
      { name: 'Orange', file: 'orange', image: 'orange.svg' },
      { name: 'Teal', file: 'teal', image: 'teal.svg' },
      { name: 'Magenta', file: 'magenta', image: 'magenta.svg' },
      { name: 'Lime', file: 'lime', image: 'lime.svg' },
      { name: 'Brown', file: 'brown', image: 'brown.svg' },
      { name: 'Red', file: 'red', image: 'red.svg' },
      { name: 'Indigo', file: 'indigo', image: 'indigo.svg' },
    ];

    this.darkColors = [
      { name: 'Blue', file: 'blue', image: 'blue.svg' },
      { name: 'Green', file: 'green', image: 'green.svg' },
      { name: 'Yellow', file: 'yellow', image: 'yellow.svg' },
      { name: 'Cyan', file: 'cyan', image: 'cyan.svg' },
      { name: 'Purple', file: 'purple', image: 'purple.svg' },
      { name: 'Orange', file: 'orange', image: 'orange.svg' },
      { name: 'Teal', file: 'teal', image: 'teal.svg' },
      { name: 'Magenta', file: 'magenta', image: 'magenta.svg' },
      { name: 'Lime', file: 'lime', image: 'lime.svg' },
      { name: 'Brown', file: 'brown', image: 'brown.svg' },
      { name: 'Red', file: 'red', image: 'red.svg' },
      { name: 'Indigo', file: 'indigo', image: 'indigo.svg' },
    ];

    this.selectedColorOptions = settingsService.SiteIsDark ? this.darkColors : this.lightColors;
    this.horizontalMenu = settingsService.NavigationIsHorizontal;
    this.staticMenuActive = this.settingsService.MenuIsStatic;
    this.changeLayout();
  }

  ngOnInit() {}

  changeLayout() {
    let mode = this.settingsService.SiteIsDark;
    this.darkMode = mode;
    if (mode === true) {
      this.menuColorMode = 'dark';
      this.menuColor = 'layout-menu-dark';
      this.selectedColorOptions = this.darkColors;
      this.layoutColor = this.selectedColorOptions[0].file;
      this.changeLightDarkLayout('layout-css', this.selectedColorOptions[0].file, 'layout-dark');
      this.changeLightDarkTheme('theme-css', 'theme-dark');
    } else {
      this.menuColorMode = 'light';
      this.menuColor = 'layout-menu-light';
      this.selectedColorOptions = this.lightColors;
      this.layoutColor = this.selectedColorOptions[0].file;
      this.changeLightDarkLayout('layout-css', this.selectedColorOptions[0].file, 'layout-light');
      this.changeLightDarkTheme('theme-css', 'theme-light');
    }
  }

  private changeLightDarkTheme(id, value) {
    const element = document.getElementById(id);
    const urlTokens = element.getAttribute('href').split('/');
    urlTokens[urlTokens.length - 1] = value + '.css';
    const newURL = urlTokens.join('/');
    this.replaceLink(element, newURL);
  }

  private changeLightDarkLayout(id, color, mode) {
    const element = document.getElementById(id);
    const urlTokens = element.getAttribute('href').split('/');
    urlTokens[urlTokens.length - 2] = color;
    urlTokens[urlTokens.length - 1] = mode + '.css';
    const newURL = urlTokens.join('/');
    this.replaceLink(element, newURL);
  }

  private replaceLink(linkElement, href) {
    if (this.isIE()) {
      linkElement.setAttribute('href', href);
    } else {
      const id = linkElement.getAttribute('id');
      const cloneLinkElement = linkElement.cloneNode(true);
      cloneLinkElement.setAttribute('href', href);
      cloneLinkElement.setAttribute('id', id + '-clone');
      linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);
      cloneLinkElement.addEventListener('load', () => {
        linkElement.remove();
        cloneLinkElement.setAttribute('id', id);
      });
    }
  }

  private isIE() {
    return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent);
  }

  onLayoutClick() {
    if (!this.topbarItemClick) {
      this.activeTopbarItem = null;
      this.topbarMenuActive = false;
    }

    if (!this.rightPanelClick) {
      this.rightPanelActive = false;
    }

    if (!this.megaMenuClick) {
      this.megaMenuActive = false;
    }

    if (!this.megaMenuMobileClick) {
      this.megaMenuMobileActive = false;
    }

    if (!this.menuClick) {
      if (this.isHorizontal()) {
        this.menuService.reset();
      }

      if (this.menuMobileActive) {
        this.menuMobileActive = false;
      }

      this.menuHoverActive = false;
    }

    this.menuClick = false;
    this.topbarItemClick = false;
    this.megaMenuClick = false;
    this.megaMenuMobileClick = false;
    this.rightPanelClick = false;
  }

  onMegaMenuButtonClick(event) {
    this.megaMenuClick = true;
    this.megaMenuActive = !this.megaMenuActive;
    event.preventDefault();
  }

  onMegaMenuClick(event) {
    this.megaMenuClick = true;
    event.preventDefault();
  }

  onTopbarItemClick(event, item) {
    this.topbarItemClick = true;

    if (this.activeTopbarItem === item) {
      this.activeTopbarItem = null;
    } else {
      this.activeTopbarItem = item;
    }

    event.preventDefault();
  }

  onRightPanelButtonClick(event) {
    this.rightPanelClick = true;
    this.rightPanelActive = !this.rightPanelActive;

    event.preventDefault();
  }

  onRightPanelClose(event) {
    this.rightPanelActive = false;
    this.rightPanelClick = false;

    event.preventDefault();
  }

  onRightPanelClick(event) {
    this.rightPanelClick = true;

    event.preventDefault();
  }

  onTopbarMobileMenuButtonClick(event) {
    this.topbarMobileMenuClick = true;
    this.topbarMobileMenuActive = !this.topbarMobileMenuActive;

    event.preventDefault();
  }

  onMegaMenuMobileButtonClick(event) {
    this.megaMenuMobileClick = true;
    this.megaMenuMobileActive = !this.megaMenuMobileActive;

    event.preventDefault();
  }

  onMenuButtonClick(event) {
    this.menuClick = true;
    this.topbarMenuActive = false;

    if (this.isMobile()) {
      this.menuMobileActive = !this.menuMobileActive;
    }

    event.preventDefault();
  }

  onSidebarClick(event: Event) {
    this.menuClick = true;
  }

  onToggleMenuClick(event: Event) {
    this.staticMenuActive = !this.staticMenuActive;
    event.preventDefault();
  }

  isDesktop() {
    return window.innerWidth > 991;
  }

  isMobile() {
    return window.innerWidth <= 991;
  }

  isHorizontal() {
    return this.horizontalMenu === true;
  }
}
